//
// GENERATED by KVision
//
package pl.finn.forms.service

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager

expect class DocumentService : IDocumentService

object DocumentServiceManager : KVServiceManager<DocumentService>(DocumentService::class) {
    init {
        bind(IDocumentService::createNewForm, HttpMethod.POST, null)
        bind(IDocumentService::editForm, HttpMethod.POST, null)
        bind(IDocumentService::saveForm, HttpMethod.POST, null)
        bind(IDocumentService::validateForm, HttpMethod.POST, null)
        bind(IDocumentService::previewForm, HttpMethod.POST, null)
    }
}
